<template>
  <v-row justify="center">
    <v-dialog v-model="attivo" persistent>
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-flex>
          <v-card>
            <v-card-title>
              <span class="text-h5"
                >Riepilogo
                </span
              >
             
            </v-card-title>
            <v-card-text>
              <v-container>
                fsdfdsf
              </v-container>
            </v-card-text>
             <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="primary darken-1" @click="validazione">
                Conferma
              </v-btn>
              <v-btn color="primary darken-1" text @click="chiudi">
                Chiudi
              </v-btn>
                      </v-card-actions>
            
            </v-card></v-flex>
      </v-form></v-dialog></v-row>
      
</template>

<script>


export default {
  name: "indirizzi",

  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    dialog: true,
   
  }),
  methods: {
    
    async chiudi() {
      if (!this.$refs.form.validate()) {
      //  await this.$store.dispatch("setStepNoCompletoEvent", 3);
      }
      this.attivo = false;
    },
    async validazione() {
      if (this.$refs.form.validate()) {
        //await this.$store.dispatch("setStepCompletoEvent", 3);
        this.attivo = false;
      }
    },

    
  },
  computed: {
    
  },
  mounted: function() {
    
    
  },
   updated: function() {
  
   
  },

  watch: {
    
}};
</script>
